export const addLoadingSpinner = () => {
  if (!document || !document.body || document.getElementById('spinner-container')) {
    return;
  }
  const spinnerContainer = document.createElement('div');
  spinnerContainer.setAttribute('id', 'spinner-container');
  const spinner = document.createElement('span');
  spinner.className = 'spinner';
  setStyle(spinnerContainer, spinner);
  spinnerContainer.appendChild(spinner);
  document.body.insertBefore(spinnerContainer, document.body.firstChild);
};

function setStyle(spinnerContainer, spinner) {
  spinnerContainer.style.width = '100%';
  spinnerContainer.style.height = '100%';
  spinnerContainer.style.backgroundColor = 'white';
  spinnerContainer.style.opacity = '0.7';
  spinnerContainer.style.position = 'absolute';
  spinnerContainer.style.top = 0;
  spinnerContainer.style.bottom = 0;
  spinnerContainer.style.right = 0;
  spinnerContainer.style.left = 0;
  spinnerContainer.style.zIndex = 99999;
  spinnerContainer.style.margin = 'auto';

  spinner.style.top = 0;
  spinner.style.bottom = 0;
  spinner.style.right = 0;
  spinner.style.left = 0;
  spinner.style.margin = 'auto';
  spinner.style.position = 'absolute';
}

export const removeLoadingIndicator = () => {
  if (!document || !document.body) {
    return;
  }
  const spinnerContainer = document.getElementById('spinner-container');
  if (!spinnerContainer) {
    return;
  }
  spinnerContainer.parentNode.removeChild(spinnerContainer);
};
